<script>
import auth from '@/services/auth'

export default {
  async beforeCreate() {
    await auth.logout()
    await this.$router.push({ name: 'Login' })
    this.$store.commit('RESET_STORE')
  }
}
</script>
